<template>
    <div class="preset-venue-create">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'presetVenueDetails' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Create Venue
                        </div>
                    </div>
                </div>
            </div>

            <hr />
        </div>
        <div class="container">
            <h3 class="section-title mt-5">Venue Detail</h3>
            <form @submit.prevent="checkForm" action="#" method="post">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Venue name * </label>
                            <input class="form-control" v-model="venueData.name" type="text" required>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Category *</label>
                            <select class="custom-select form-control" v-model="venueData.category_id" name="category" id="category" required>
                                <option value="1">Public Place</option>
                                <option value="2">Horeca</option>
                                <option value="3">Traditional Market</option>
                                <option value="4">Terminal / Port / Bus Station</option>
                                <option value="5">Office</option>
                                <option value="6">Campus</option>
                                <option value="7">Tourism Spot</option>
                                <option value="8">Others</option>
                                <option value="9">Goverment Public Service</option>
                                <option value="10">Modern Market</option>
                                <option value="11">Street Food Stall</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Venue Description </label>
                            <input class="form-control" v-model="venueData.desc" type="text">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Validity *</label>
                            
                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input v-model="venueData.valid" id="valid" type="radio" name="validity" value="1" required class="custom-control-input">
                                    <label class="" for="valid">Valid</label>
                                </div>
                                <div class="custom-control-inline pill-radio">
                                    <input v-model="venueData.valid" id="invalid" type="radio" name="validity" value="0" required class="custom-control-input">
                                    <label class="" for="invalid">Invalid</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Division *</label>

                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input @change="onChangeDivision" v-model="venueData.division" type="radio" id="north" name="division" value="0" required class="custom-control-input" :disabled="isDivisionRestrict">
                                    <label class="" for="north">East</label>
                                </div>
                                <div class="custom-control-inline pill-radio">
                                    <input @change="onChangeDivision" v-model="venueData.division" type="radio" id="south" name="division" value="1" required class="custom-control-input" :disabled="isDivisionRestrict">
                                    <label class="" for="south">West</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Region *</label>
                            <select @change="onChangeRegion" class="custom-select form-control" v-model="venueData.region_id" name="region" id="region" required :disabled="isRegionRestrict">
                                <option v-for="region in regionOptions" v-bind:key="region.id" :value="region.id">{{region.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Primary Area *</label>
                            <select class="custom-select form-control" v-model="venueData.area_id" name="area" id="area" required :disabled="isAreaRestrict">
                                <option v-for="area in areaOptions" v-bind:key="area.id" :value="area.id">{{area.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">District </label>
                            <input class="form-control" v-model="venueData.district" type="text">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Sub District </label>
                            <input class="form-control" v-model="venueData.sub_district" type="text">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Address </label>
                            <input class="form-control" v-model="venueData.address" type="text">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Latitude *</label>
                            <input class="form-control" v-model="venueData.latitude" type="text" required>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Longitude *</label>
                            <input class="form-control" v-model="venueData.longitude" type="text" required>
                        </div>
                    </div>
                </div>

                <button class="btn btn-ecdc btn-shadow">Create</button>
            </form>
        </div>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getAreas, getRegions, storePresetVenue, checkPermission } from '../api'
import { getAuth } from '../helpers'
import Loader from './Loader.vue'

export default {
    components: {
        appLoader: Loader
    },
    data() {
        return {
            venueData: {
                name: "",
                category_id: 1,
                desc: "",
                valid: 1,
                area_id: getAuth()['areaId'],
                region_id: getAuth()['regionId'],
                division: getAuth()['division'],
                district: "",
                sub_district: "",
                address: "",
            },
            locationCategories: {data:{result:{}}},
            regions: "",
            regionOptions: [],
            areas: "",
            areaOptions: [],
            defaultAreaId: getAuth()['areaId'],
            defaultRegionId: getAuth()['regionId'],
            defaultDivision: getAuth()['division'],
            isDivisionRestrict: true,
            isRegionRestrict: true,
            isAreaRestrict: true,
            isLoading: false
        }
    },
    async mounted() {
        const _this = this;
        this.getAreas();
        this.getRegions();
        this.isDivisionRestrict = await this.checkPermission('restrict division');
        this.isRegionRestrict = await this.checkPermission('restrict region');
        this.isAreaRestrict = await this.checkPermission('restrict area');

        const foundRegions = this.regions.filter(value => value.division == this.venueData.division);
        foundRegions.forEach(value => {
            _this.regionOptions.push(value);
        });

        const foundAreas = this.areas.filter(value => value.region_id == this.venueData.region_id);                
        foundAreas.forEach(value => {
            _this.areaOptions.push(value);
        });

        this.isLoading = false;  
    },
    methods: {
        async getAreas() {

            try {
                const result = await getAreas()
                this.areas = result.data.data;
            }
            catch(err) {

                alert(err);
            }
        },
        async getRegions() {

            try {
                const result = await getRegions()
                this.regions = result.data.data;
            }
            catch(err) {

                alert(err);
            }
        },
        async checkPermission(permission) {
            try {
                const result = await checkPermission({permission:permission})
                return result.data.data;
            }
            catch(err) {

                alert(err);
            }
        },
        async checkForm(e) {

            if(!((isFinite(this.venueData.latitude) && Math.abs(this.venueData.latitude) <= 90)) || !(isFinite(this.venueData.longitude) && Math.abs(this.venueData.longitude) <= 180)) {
                alert("wrong format latitude longitude");
                return
            }

            try {

                this.isLoading = true;
                const result = await storePresetVenue(this.venueData);

                if(result.data.success) {

                    this.$router.push({ name: "presetVenueDetails" });
                }
                else {
                    alert(result.data.message);
                    this.isLoading = false;
                }
            }
            catch(err) {

                alert(err);
                this.isLoading = false;  
            }

            e.preventDefault();
        },
        checkDisabled (id){

            if(id == this.id) {

                return false;
            }
            else if(id == null) {

                return false;
            }
            else {

                return true;
            }
        },
        onChangeDivision() {
            
            const _this = this;
            this.regionOptions = [];
            this.venueData.region_id = "";
            this.areaOptions = this.areas;
            this.venueData.area_id = "";

            if(this.venueData.division) {

                const found = this.regions.filter(value => value.division == this.venueData.division);

                found.forEach(value => {
                    _this.regionOptions.push(value);
                });
            }
            else {

                this.regionOptions = this.regions;
            }
        },
        onChangeRegion() {
            
            const _this = this;
            this.areaOptions = [];
            this.venueData.area_id = "";

            if(this.venueData.region_id) {

                const found = this.areas.filter(value => value.region_id == this.venueData.region_id);
                
                found.forEach(value => {
                    _this.areaOptions.push(value);
                });
            }
            else {

                this.areaOptions = this.areas;
            }
        }
    }
}
</script>